import * as React from "react";
import { SFC } from "react";
import { Header } from "semantic-ui-react";
import Notice from "../../../domain/notice/Notice";
import Notices from "../../../domain/notice/Notices";
import NoticeDetail from "./NoticeDetail";

interface Props {
  notices: Notices;
}

const NoticeList: SFC<Props> = (props: Props) => {
  const {notices} = props;
  return (
    <>
      {
        notices.isEmpty()
          ? <Header color="grey" as="h3">お知らせはありません</Header>
          : notices.list.map((notice: Notice, index) => <NoticeDetail key={ index } notice={ notice }/>)
      }
    </>
  )
};

export default NoticeList;
